export default __webpack_public_path__ + "static/media/Hostinger.9e3931ab.png";